import type { DayCategoryCompletion } from '@travel-planner/shared/schemas';
import { joinCss, pickCss } from '@/shared/lib/css-utils';
import css from './category-progress-bar.module.scss';

const styles = {
  root: pickCss(css, css.root),
  header: pickCss(css, css.header),
  label: pickCss(css, css.label),
  count: pickCss(css, css.count),
  track: pickCss(css, css.track),
  segment: pickCss(css, css.segment),
};

type CategoryProgressBarProps = {
  dayLabel: string;
  /** Completion of each of the 4 categories, in display order. */
  segments: ReadonlyArray<DayCategoryCompletion>;
};

/**
 * CategoryProgressBar — pen component `Yxb34`. A 4-segment progress strip
 * showing how many of a day's categories are complete. Green = complete,
 * amber = partial, grey = missing.
 */
export const CategoryProgressBar = ({
  dayLabel,
  segments,
}: CategoryProgressBarProps) => {
  const completed = segments.filter((s) => s === 'complete').length;
  return (
    <div className={styles.root()}>
      <div className={styles.header()}>
        <span className={styles.label()}>{dayLabel} progress</span>
        <span className={styles.count()}>
          {completed} / {segments.length} categories
        </span>
      </div>
      <div className={styles.track()}>
        {segments.map((segment, i) => (
          <span
            className={joinCss(styles.segment({ state: segment }))}
            key={`${i}-${segment}`}
          />
        ))}
      </div>
    </div>
  );
};
